import { render } from "./TenantDetailCard.vue?vue&type=template&id=44cb2404&scoped=true"
import script from "./TenantDetailCard.vue?vue&type=script&lang=js"
export * from "./TenantDetailCard.vue?vue&type=script&lang=js"

import "./TenantDetailCard.vue?vue&type=style&index=0&id=44cb2404&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cb2404"]])

export default __exports__